<template>
	<i :class="classes" aria-hidden="true"></i>
</template>

<script>
export default {
	props: {
		// the class name of the icon. The prefix "fa-" is optional.
		icon: String,

		// flag indicating loading state of the icon
		loading: {
			type: Boolean,
			default: false
		},

		// classes to be added while loading
		classLoading: {
			type: String,
			default: "fa-circle-notch"
		},

		// classes to be added while not loading
		classIdle: {
			type: String,
			default: ""
		}
	},

	computed: {
		classes() {
			const classes = [];
			const faSplit = this.icon.split();
			let faClass = "";
			let faType = "fa";

			if (faSplit.length > 0 && (faSplit[0] === "fa" || faSplit[0] === "fab" || faSplit[0] === "far")) {
				faType = faSplit[0];
				faClass = faSplit[1];
			} else {
				faClass = faSplit[0];
			}
			classes.push(faType, this.classIdle);

			if (this.loading) {
				classes.push("fa-spin", this.classLoading);
			} else {
				let iconClass = faClass.substr(0, 3) === "fa-" ? faClass : "fa-" + faClass;

				classes.push(iconClass, this.classIdle);
			}

			return classes;
		}
	}
};
</script>